/* eslint-disable prefer-destructuring */
import isLocalhost from "./util/isLocalhost"

export const BUCKET_DESTINATION = import.meta.env.VITE_BUCKET_DESTINATION
export const BASE_PATH = isLocalhost() ? '/' : import.meta.env.VITE_BASE_PATH

// where the puzzle json files are loaded from
export const GAME_ROOT = import.meta.env.VITE_GAME_ROOT

export const SHARE_LINK = import.meta.env.VITE_SHARE_LINK
export const API_ENDPOINT = import.meta.env.VITE_HTTP_API_ENDPOINT
export const PID_URL = import.meta.env.VITE_PID_URL

export const GOOGLE_ANALYTICS_ID_1 = import.meta.env.VITE_GOOGLE_ANALYTICS_ID_1
export const GOOGLE_ANALYTICS_ID_2 = import.meta.env.VITE_GOOGLE_ANALYTICS_ID_2

export const ADS_ENABLED = import.meta.env.VITE_ADS_ENABLED === 'true'
export const USE_REST_API = import.meta.env.VITE_USE_REST_API === 'true'

export const localStoragePrefix = import.meta.env.VITE_LOCAL_STORAGE_PREFIX || ''

export const GAME_IDS = {
	DAILY5: 'daily5',
	DAILY5_ARCHIVE: 'daily5_archive',
} as const

export const DAILY5_START_DATE = '2024-02-21'

export const STATS_STORAGE_ID = (gameId: string): string => `${localStoragePrefix}${gameId}_stats`
export const STATE_STORAGE_ID = (gameId: string): string => `${localStoragePrefix}${gameId}_state`
export const RESULTS_STORAGE_ID = (gameId: string): string =>`${localStoragePrefix}${gameId}_results`
export const TIMINGS_STORAGE_ID = (gameId: string): string => `${localStoragePrefix}${gameId}_timings`
export const LAST_SYNCED_STORAGE_ID = (gameId: string): string => `${localStoragePrefix}${gameId}_lastSynced`

export const GAME_STORAGE_KEYS = {
	// Daily Game
	DAILY5_RESULTS: RESULTS_STORAGE_ID(GAME_IDS.DAILY5),
	DAILY5_STATE: STATE_STORAGE_ID(GAME_IDS.DAILY5),
	DAILY5_STATS: STATS_STORAGE_ID(GAME_IDS.DAILY5),
	DAILY5_TIMINGS: TIMINGS_STORAGE_ID(GAME_IDS.DAILY5),
	// Daily Archive
	DAILY5_ARCHIVE_RESULTS: RESULTS_STORAGE_ID(GAME_IDS.DAILY5_ARCHIVE),
	DAILY5_ARCHIVE_STATE: STATE_STORAGE_ID(GAME_IDS.DAILY5_ARCHIVE),
	DAILY5_ARCHIVE_TIMINGS: TIMINGS_STORAGE_ID(GAME_IDS.DAILY5_ARCHIVE),
	DAILY5_ARCHIVE_LAST_SYNCED: LAST_SYNCED_STORAGE_ID(GAME_IDS.DAILY5_ARCHIVE),
}

// Gameplay Constants
export const ANIMATION_DURATION = 220 // --easing-duration in CSS
export const INCORRECT_FREEZE_DURATION = ANIMATION_DURATION * 8
export const TOTAL_WORDS = 10
export const INITIAL_INSTRUCTION_DELAY = 3000
export const NEW_INSTRUCTION_DELAY = 5000

// App events
export const EVENTS = {
	DAILY5_STATE_CHANGE: 'DAILY5_STATE_CHANGE',
	DAILY5_ARCHIVE_STATE_CHANGE: 'DAILY5_ARCHIVE_STATE_CHANGE',
	STATS_CHANGED: 'STATS_CHANGED',
	SETTINGS_CHANGED: 'SETTINGS_CHANGED'
} as const